import {en} from './locales/en'

export const translations = {
  en: en,
}
